'use strict';

angular.module('shiftTraderApp')
  .factory('AvailabilitySets', function (ServerUrls, Session, $http, $injector, TimeService, $rootScope, $q) {
    var STATE_MAPPING = {
      PENDING: 0,
      IN_REVIEW: 1,
      APPROVED: 2,
      DISAPPROVED: 3
    };

    var endpointName = 'availability_sets/';

    var AvailabilitySet = function(values) {
      var A = {};

      A.$reinitialize = function(data) {
        angular.extend(A, data);

        if (!_.isNull(A.desired_effective_date)) {
          A.desired_effective_date = moment.utc(A.desired_effective_date).tz(Session.getTimezone());
        }

        if (!_.isNull(A.approved_at)) {
          A.approved_at = moment.utc(A.approved_at).tz(Session.getTimezone());
        }

        if (!_.isNull(A.effective_date)) {
          A.effective_date = moment.utc(A.effective_date).tz(Session.getTimezone());
        }

        if (!_.isNull(A.ineffective_date)) {
          A.ineffective_date = moment.utc(A.ineffective_date).tz(Session.getTimezone());
        }

        A.created_at = moment.utc(A.created_at).tz(Session.getTimezone());
        A._created_at_unix = A.created_at.unix();

        var AR = $injector.get('AvailabilityRules');

        try {
          A.availability_rules = _.map(A.availability_rules, function(rule) {
            return AR.initWithData(rule);
          }, this);
        } catch (e) {
          Rollbar.error(e, { availability_set_id: A.id });
        }

        var UACR = $injector.get('UserAvailabilityChangeRequests');
        if (A.user_availability_change_request) {
          A.user_availability_change_request = UACR.initWithData(A.user_availability_change_request);
        }

        if (A.metadata && A.metadata.in_review_date) {
          A.inReviewDate = moment.utc(A.metadata.in_review_date).tz(Session.getTimezone());
        }

      };

      A.$reinitialize(values);

      A.$belongsToChangeRequest = function() {
        return !_.isUndefined(A.user_availability_change_request_id) && !_.isNull(A.user_availability_change_request_id);
      };

      A.$isInEffect = function(dt) {
        var testDt;

        if (_.isUndefined(dt)) {
          testDt = TimeService.getNowInStoreTime();
        } else {
          testDt = dt;
        }

        return (_.isNull(A.effective_date) || A.effective_date.isBefore(testDt) || A.effective_date.isSame(testDt, 'second')) &&
            (_.isNull(A.ineffective_date) || A.ineffective_date.isAfter(testDt));
      };

      A.$stateInWords = function() {
        if (A.state === STATE_MAPPING.PENDING) {
          return 'Pending';
        } else if (A.state === STATE_MAPPING.IN_REVIEW) {
          return 'In Review';
        } else if (A.state === STATE_MAPPING.APPROVED) {
          return 'Approved';
        } else if (A.state === STATE_MAPPING.DISAPPROVED) {
          return 'Disapproved';
        } else {
          return 'Unknown';
        }
      };

      A.$isApprovedOrDisapproved = function() {
        return A.$isApproved() || A.$isDisapproved();
      };

      A.$isPending = function() {
        return A.state === STATE_MAPPING.PENDING;
      };

      A.$isInReview = function() {
        return A.state === STATE_MAPPING.IN_REVIEW;
      };

      A.$isApproved = function() {
        return A.state === STATE_MAPPING.APPROVED;
      };

      A.$isDisapproved = function() {
        return A.state === STATE_MAPPING.DISAPPROVED;
      };



      A.$makeInactive = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          active: false
        })
          .then(function(response) {
            that.active = false;
            return response.data;
          }, function(response) {
            console.log('Error in AvailabilitySet.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$update = function(updateData) {
        $rootScope.$broadcast('MWPCompositeAvailabilityService:invalidateCache');
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, updateData)
            .then(function(response) {
              console.log('inSuccess: ', response.data);
              $rootScope.$broadcast('sa:availabilityRequestStateChange');
              return AvailabilitySets.initWithData(response.data);
            }, function(response) {
              return $q.reject(response);
            });
      };

      A.$sendMessage = function(messageText, usr) {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          message: {
            text: messageText,
            user_id: usr.id,
            user_first_name: usr.first_name,
            user_last_name: usr.last_name
          }
        })
            .then(function(response) {
              that.messages = response.data.messages;
              return response;
            }, function(response) {
              console.log('Error in AvailabilitySet.$approve');
              return $q.reject(response);
            });
      };

      return A;
    };

    var AvailabilitySets = {};

    AvailabilitySets.create = function (data) {
      $rootScope.$broadcast('MWPCompositeAvailabilityService:invalidateCache');
      return $http.post(ServerUrls.current.railsApi + endpointName, data)
        .then(function (response) {
          $rootScope.$broadcast('sa:availabilityRequestStateChange');
          return new AvailabilitySet(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    AvailabilitySets.getById = function(setId) {
      return $http.get(ServerUrls.current.railsApi + endpointName + '/' + setId)
          .then(function(response) {
            return new AvailabilitySet(response.data);
          }, function(response) {
            return $q.reject(response);
          });
    };

    AvailabilitySets.getAll = function(params) {
      var config = {
        params: _.extend({}, params)
      };

      return $http.get(ServerUrls.current.railsApi + endpointName, config)
          .then(function(response) {
            return _.map(response.data, function(ar) {
              return new AvailabilitySet(ar);
            });
          }, function(response) {
            return $q.reject(response);
          });

    };

    AvailabilitySets.getUserPendingSets = function(userId, extraParams) {
      var data = {
        user_id: userId,
        state: STATE_MAPPING.PENDING.toString()
      };

      if (extraParams) {
        _.extend(data, extraParams);
      }

      return AvailabilitySets.getAll(data);
    };

    AvailabilitySets.getUserPendingAndInReviewSets = function(userId, extraParams) {
      var data = {
        user_id: userId,
        state: STATE_MAPPING.PENDING.toString() + ',' + STATE_MAPPING.IN_REVIEW.toString()
      };

      if (extraParams) {
        _.extend(data, extraParams);
      }

      return AvailabilitySets.getAll(data);
    };

    AvailabilitySets.initWithData = function(data) {
      return new AvailabilitySet(data);
    };

    AvailabilitySets.stateMapping = STATE_MAPPING;

    return AvailabilitySets;
  });
